import { CtaButton } from '@tkww/orion-web-ds-action';
import { type ClassesRecord, compose } from '@xo-union/react-css-modules';
import {
	Checkbox,
	type CheckboxClasses,
	MultiSelectGroup,
} from '@xo-union/tk-component-switches';
import { useAtom, useAtomValue } from 'jotai';
import React, { type FC } from 'react';
import {
	areStarRatingsSavedAtom,
	currentStarRatingsAtom,
	previousStarRatingsAtom,
} from '../../../../atoms';
import { useGetOptions } from '../../../../hooks/use-get-options';
import { useStarReviews } from '../../../../hooks/use-star-reviews';
import Styles from './styles.scss';

export interface BodyProps {
	handleClose?: () => void;
	isMobile?: boolean;
}

const getCheckboxClasses = (hasReviews: boolean) => {
	return compose<CheckboxClasses, ClassesRecord<CheckboxClasses>>({
		container: Styles.container,
	});
};

const Body: FC<BodyProps> = (props) => {
	const { handleClose, isMobile = true } = props;
	const [currentStarRatings, setCurrentStarRatings] = useAtom(
		currentStarRatingsAtom,
	);
	const previousStarRatings = useAtomValue(previousStarRatingsAtom);
	const [areStarRatingsSaved, setAreStarRatingsSaved] = useAtom(
		areStarRatingsSavedAtom,
	);
	const options = useGetOptions();
	const { handleClearAll, handleSave } = useStarReviews(handleClose);

	const handleChange = (values: string[]) => {
		setCurrentStarRatings(values);

		const hasPendingChanges = !(
			previousStarRatings.every((p) => values.includes(p)) &&
			previousStarRatings.length === values.length
		);
		if (hasPendingChanges) {
			setAreStarRatingsSaved(false);
		} else {
			setAreStarRatingsSaved(true);
		}
	};

	return (
		<div className={Styles.bodyContainer}>
			<MultiSelectGroup
				values={currentStarRatings}
				onValuesChange={handleChange}
			>
				{options.map(({ hasReviews, starRating }) => (
					<Checkbox
						classes={getCheckboxClasses(hasReviews)}
						value={starRating}
						key={starRating}
					>
						{starRating}
					</Checkbox>
				))}
			</MultiSelectGroup>
			{!isMobile && (
				<div className={Styles.saveContainer}>
					<div className={Styles.buttonGroup}>
						<CtaButton
							onClick={handleClearAll}
							className={Styles.clearButton}
							styleType="tertiary-alternative"
							size="md"
						>
							Clear
						</CtaButton>
						<CtaButton
							onClick={handleSave}
							disabled={areStarRatingsSaved}
							active={!areStarRatingsSaved}
							className={Styles.saveButton}
							styleType="tertiary-alternative"
							size="md"
						>
							Save
						</CtaButton>
					</div>
				</div>
			)}
		</div>
	);
};

export { Body };
